import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "account-is-not-main" }

import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import { ModalContent, ModalFooter, modalVariant, type ModalVariant } from '@exchange/libs/modals/src';

import TransactionMessage from './TransactionMessage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountIsNotMain',
  props: {
  operation: { type: String as PropType<'deposit' | 'withdraw'>, required: true },
  variant: { type: String as PropType<ModalVariant>, default: modalVariant.light },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useI18n({ useScope: 'global' });

const title = computed(() => t('modules.transactions.subaccountTransfer.notMainSubaccount.title'));
const text = computed(() => t(`modules.transactions.subaccountTransfer.notMainSubaccount.text.${props.operation}`));

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ModalContent), { variant: __props.variant }, {
      default: _withCtx(() => [
        _createVNode(TransactionMessage, {
          title: title.value,
          text: text.value
        }, null, 8, ["title", "text"])
      ]),
      _: 1
    }, 8, ["variant"]),
    _createVNode(_unref(ModalFooter), null, {
      default: _withCtx(() => [
        _createVNode(_component_x_button, {
          variant: "primary",
          text: _ctx.$t('fundamentals.close'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
        }, null, 8, ["text"])
      ]),
      _: 1
    })
  ]))
}
}

})